import { camelizeKeys } from '@/utils'
import moment, { MomentInput, unitOfTime } from 'moment'
import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import AuthorizationMixin from '@/routing/AuthorizationMixin'

export default mixins(AuthorizationMixin).extend({
  components: {
    ChooseDays: () => import('@/components/workflow/ChooseDays.vue'),
    Datepicker: () => import('@/components/workflow/Datepicker.vue'),
    LetterDisplay: () => import('@/components/letters/Display.vue'),
    LetterEditor: () => import('./InTaskLetterEditor.vue'),
    Pathev: () => import('@/survey/measures/pathev/Pathev.vue'),
    Phq9: () => import('@/survey/measures/phq9/Phq9.vue'),
    Process: () => import('@/components/workflow/Process.vue'),
    SewipPatients: () => import('@/survey/measures/sewip/SewipPatients.vue'),
    Supplemental: () => import('@/components/layout/Collapse.vue'),
    Task: () => import('@/components/workflow/Task'),
    Timer: () => import('@/components/workflow/Timer'),
    Gateway: () => import('@/components/workflow/Gateway'),
  },
  data() {
    const templates = this.$store.getters['letterTemplates/storedObjectsArray']
    const showWelcomePrompts = (sessionStorage.getItem('showWelcomePrompts') || '1') === '1'
    return {
      initParams: {
        directionality: 'rtl',
        language: 'en',
        plugins: ['paste', 'link', 'template'],
        templates,
      },
      showWelcomePrompts,
    }
  },
  methods: {
    fromNow(rawDate: MomentInput, unit: unitOfTime.Diff = 'days', precise: boolean = true): number {
      return moment(rawDate).diff(new Date(), unit, precise)
    },
    ago(rawDate: MomentInput, unit: unitOfTime.Diff = 'days', precise: boolean = true): number {
      return -this.fromNow(rawDate, unit, precise)
    },
    hideWelcomePrompts() {
      this.showWelcomePrompts = false
    },
    withSurvey(survey: string, data: any) {
      return {
        surveyData: {
          type: 'string',
          value: JSON.stringify(camelizeKeys(data, '_-')),
        },
        surveyType: {
          type: 'string',
          value: survey.toLowerCase(),
        },
      }
    },
  },
  watch: {
    showWelcomePrompts(nowIs: boolean, was: boolean) {
      if (nowIs !== was) {
        sessionStorage.setItem('showWelcomePrompts', nowIs ? '1' : '0')
      }
    },
  },
})
